import {useController, useFormContext} from 'react-hook-form';
import {Trans, useTranslation} from 'react-i18next';
import {Checkbox, MediaObject, Stack, Text} from '@treatwell/ui';
import type {FormInputs} from '../Form';
import {LegalLinkModal} from '../LegalLinkModal';
import styles from './MarketingConsent.module.css';

export const MarketingConsent = () => {
  const {t} = useTranslation();
  const {control} = useFormContext<FormInputs>();
  const {field} = useController({
    control,
    name: 'marketingAllowed',
    defaultValue: false,
  });
  const {value, ...checkboxField} = field;

  return (
    <Stack space="sm" className={styles.root}>
      <MediaObject align="start" space="sm">
        <div className={styles.checkbox}>
          <Checkbox
            id="marketingAllowed"
            {...checkboxField}
            checked={value}
            onChange={(event) => field.onChange(event.target.checked)}
          />
        </div>
        <Text type="body" as="label" htmlFor="marketingAllowed">
          {t('register.marketingConsent.consentText')}
        </Text>
      </MediaObject>
      <Trans i18nKey="register.marketingConsent.helperText">
        <Text type="caption" className={styles.helperText}>
          You can unsubscribe at any time by clicking the unsubscribe link in
          those emails. Find out more about how Treatwell stores, uses and
          protects your data in our{' '}
          <LegalLinkModal
            pageType="PRIVACY_POLICY"
            label={t('register.marketingConsent.privacyPolicyLabel')}
            data-cy="PrivacyPolicy"
          />
          .
        </Text>
      </Trans>
    </Stack>
  );
};
